import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "nav navbar-nav ml-auto navbar-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'home' },
        class: "navbar-brand"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_fa_icon, { icon: "home" }),
          _createTextVNode(" MontyBuy")
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.version), 1)
    ])
  ]))
}